import { Injectable, OnDestroy } from '@angular/core';
import { Nexus } from '@tomandco/nexus-api-types';
import { Subscription } from 'rxjs';
import { ProductConfiguration } from '../product-configuration';

@Injectable()
export class ProductConfigurationBaseService implements OnDestroy {
    /**
     * Configuration service
     */
    protected configuration!: ProductConfiguration;

    /**
     * Subscriptions
     */
    protected subscriptions = new Subscription();

    /**
     * Init method to inject configuration
     */
    init(configuration: ProductConfiguration) {
        this.configuration = configuration;
    }

    /**
     * Cleanup
     */
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Convert configuration to basket request
     * @returns
     */
    toBasketRequest(): Nexus.Lib.Basket.AddToBasketData | Nexus.Lib.Basket.AddToBasketData[] {
        return {
            id: this.configuration.product$.value.id,
            qty: this.configuration.qty$.value,
            options: this.configuration.customOptionsService.getRequestOptions(this.configuration.customOptions$.value)
        };
    }
}
